// Storybook-style plant shapes for the Mood Garden (drawn at origin, base at 0,0, growing upward)
const Stem = ({ h, bend = 0 }) => (
  <path d={`M0 0 Q${bend} ${-h / 2} ${bend / 2} ${-h}`} stroke="#5E9B5A" strokeWidth="3" fill="none" strokeLinecap="round" />
);
const Leaf = ({ y, flip }) => (
  <path d={`M0 ${y} q${flip ? -14 : 14} -6 ${flip ? -18 : 18} -16 q${flip ? 2 : -2} 10 ${flip ? 18 : -18} 16z`} fill="#7DB874" />
);

const Sunflower = ({ color }) => (
  <g>
    <Stem h={70} bend={4} /><Leaf y={-24} /><Leaf y={-40} flip />
    <g transform="translate(2,-72)">
      {Array.from({ length: 12 }, (_, i) => <ellipse key={i} rx="5" ry="12" cy="-12" fill={color} transform={`rotate(${i * 30})`} />)}
      <circle r="9" fill="#8A5A2B" /><circle r="5" fill="#6B4320" />
    </g>
  </g>
);

const Tulip = ({ color }) => (
  <g>
    <Stem h={58} bend={-3} /><Leaf y={-18} flip />
    <path d="M-12 -60 Q-13 -80 -6 -86 L-2 -76 L2 -88 L6 -76 L10 -86 Q15 -80 12 -60 Q0 -52 -12 -60z" fill={color} transform="translate(-1,0)" />
  </g>
);

const Lavender = ({ color }) => (
  <g>
    {[-6, 0, 6].map((dx, k) => (
      <g key={dx} transform={`translate(${dx},0) rotate(${dx * 1.5})`}>
        <Stem h={62 - k * 4} />
        {Array.from({ length: 7 }, (_, i) => <ellipse key={i} cx={i % 2 ? 2 : -2} cy={-36 - i * 4.5 + k * 4} rx="3.2" ry="4.4" fill={color} opacity={0.75 + (i % 3) * 0.08} />)}
      </g>
    ))}
  </g>
);

const Bluebell = ({ color }) => (
  <g>
    <path d="M0 0 Q2 -40 -2 -56 Q8 -66 20 -60" stroke="#5E9B5A" strokeWidth="3" fill="none" strokeLinecap="round" /><Leaf y={-14} />
    {[[0, -56], [10, -62], [20, -60]].map(([x, y]) => (
      <path key={x} d={`M${x - 5} ${y + 4} q5 -12 10 0 l-1 6 l-2 -3 l-2 4 l-2 -4 l-2 3z`} fill={color} />
    ))}
  </g>
);

const Snowdrop = ({ color }) => (
  <g>
    <path d="M0 0 Q1 -34 4 -48 Q10 -54 12 -46" stroke="#5E9B5A" strokeWidth="2.5" fill="none" strokeLinecap="round" /><Leaf y={-10} flip />
    <path d="M7 -44 q5 -2 10 0 q2 10 -5 16 q-7 -6 -5 -16z" fill={color} stroke="#C9CFE0" strokeWidth="0.8" />
    <circle cx="12" cy="-44" r="1.6" fill="#7DB874" />
  </g>
);

const Marigold = () => (
  <g>
    <Stem h={50} bend={2} /><Leaf y={-16} /><Leaf y={-26} flip />
    <g transform="translate(1,-54)">
      <circle r="13" fill="#F59E0B" opacity="0.35" />
      {Array.from({ length: 10 }, (_, i) => <ellipse key={i} rx="4.2" ry="8" cy="-7" fill="#F6B92B" stroke="#E08A00" strokeWidth="0.6" transform={`rotate(${i * 36})`} />)}
      {Array.from({ length: 7 }, (_, i) => <ellipse key={`i${i}`} rx="3" ry="5" cy="-4" fill="#FFD25A" transform={`rotate(${i * 51 + 18})`} />)}
      <circle r="3.4" fill="#C2410C" />
    </g>
  </g>
);

const Sparkle = ({ x, y, s = 1 }) => (
  <path className="mm-twinkle" d="M0 -5 L1.2 -1.2 L5 0 L1.2 1.2 L0 5 L-1.2 1.2 L-5 0 L-1.2 -1.2z" fill="#FFF7C2" transform={`translate(${x},${y}) scale(${s})`} />
);

const FriendRose = ({ color = "#F28FAD" }) => (
  <g>
    <Stem h={60} bend={-2} /><Leaf y={-20} /><Leaf y={-34} flip />
    <g transform="translate(-1,-66)">
      <circle r="17" fill={color} opacity="0.35" className="mm-glow" />
      <path d="M0 10 C-18 -2 -14 -16 -6 -16 C-2 -16 0 -12 0 -10 C0 -12 2 -16 6 -16 C14 -16 18 -2 0 10z" fill={color} stroke="#D94F7A" strokeWidth="1" />
      <path d="M-5 -7 q5 -5 10 0 q-5 6 -10 0z" fill="#fff" opacity="0.45" />
    </g>
    <Sparkle x={13} y={-84} /><Sparkle x={-15} y={-74} s={0.6} />
  </g>
);

const ForgetMeNot = () => (
  <g>
    {[-7, 0, 7].map((dx, k) => (
      <g key={dx} transform={`translate(${dx},0) rotate(${dx * 1.2})`}>
        <Stem h={86 - k * 8} bend={dx / 2} />
        {[0, 1, 2].map((j) => (
          <g key={j} transform={`translate(${(j - 1) * 6},${-84 + k * 8 + j * 7})`}>
            {Array.from({ length: 5 }, (_, i) => <circle key={i} r="2.8" cy="-3" fill="#9C7BD8" transform={`rotate(${i * 72})`} />)}
            <circle r="1.5" fill="#FFD25A" />
          </g>
        ))}
      </g>
    ))}
    <Leaf y={-18} /><Sparkle x={14} y={-92} s={0.7} />
  </g>
);

const Blossom = () => (
  <g>
    <path d="M0 0 Q-4 -40 4 -64 Q12 -74 26 -78 M2 -50 Q-10 -60 -20 -62" stroke="#7A5240" strokeWidth="3" fill="none" strokeLinecap="round" />
    {[[26, -78], [16, -72], [6, -66], [-20, -62], [-10, -58], [0, -82]].map(([x, y]) => (
      <g key={`${x}${y}`} transform={`translate(${x},${y})`}>
        {Array.from({ length: 5 }, (_, i) => <ellipse key={i} rx="2.6" ry="4" cy="-3.5" fill="#F9C5D8" stroke="#EE9AB9" strokeWidth="0.5" transform={`rotate(${i * 72})`} />)}
        <circle r="1.4" fill="#D94F7A" />
      </g>
    ))}
    <Sparkle x={-24} y={-76} s={0.7} />
  </g>
);

export const FLOWERS = { friendrose: FriendRose, forgetmenot: ForgetMeNot, blossom: Blossom, marigold: Marigold, sunflower: Sunflower, tulip: Tulip, lavender: Lavender, bluebell: Bluebell, snowdrop: Snowdrop };

export const Fern = ({ flip }) => (
  <g transform={flip ? "scale(-1,1)" : undefined}>
    {[0, 1, 2].map((k) => (
      <g key={k} transform={`rotate(${-28 + k * 26})`}>
        <path d="M0 0 Q4 -24 0 -44" stroke="#4E8A4A" strokeWidth="2" fill="none" />
        {Array.from({ length: 6 }, (_, i) => (
          <g key={i} transform={`translate(${i % 2 ? 1 : 0},${-8 - i * 6})`}>
            <ellipse cx="-5" rx="5" ry="2.2" fill="#6FAE66" transform="rotate(-20)" /><ellipse cx="5" rx="5" ry="2.2" fill="#6FAE66" transform="rotate(20)" />
          </g>
        ))}
      </g>
    ))}
  </g>
);

export const Butterfly = ({ hue }) => (
  <g>
    <g className="mm-flutter"><ellipse cx="-6" cy="-3" rx="7" ry="5" fill={hue} /><ellipse cx="-5" cy="4" rx="4.5" ry="3.5" fill={hue} opacity="0.85" /></g>
    <g className="mm-flutter mm-flutter-r"><ellipse cx="6" cy="-3" rx="7" ry="5" fill={hue} /><ellipse cx="5" cy="4" rx="4.5" ry="3.5" fill={hue} opacity="0.85" /></g>
    <ellipse rx="1.4" ry="6" fill="#4B3B5E" />
  </g>
);
